<ngx-spinner [fullScreen]="false" bdColor="rgba(0,0,0,0.2)" type="ball-spin" size="default"> </ngx-spinner>

<mat-tab-group mat-align-tabs="center" (selectedIndexChange)="changeSelectedRanking($event)">
    <mat-tab *ngFor="let ranking of rankings" [label]="ranking.name">
        <div *ngIf="leaderboardsPodium?.length == 0" fxLayout="row" fxLayoutAlign="center center" class="list-empty">
            {{ "LEADERBOARD_LIST.EMPTY" | translate }}
        </div>
        <app-leaderboard-podium [leaders]="leaderboardsPodium"></app-leaderboard-podium>
        <app-leaderboard-list *ngIf="leaderboards?.length > 0" [leaderboards]="leaderboards"></app-leaderboard-list>
        <app-leaderboard-list
            *ngIf="userLeaderboards?.length > 0"
            [leaderboards]="userLeaderboards"
        ></app-leaderboard-list>
    </mat-tab>
</mat-tab-group>
